<template>
  <div>
     <transition name="fades">
    <div v-if="fundata.value" :is='fundata.name' :msg='fundata.msg'  @fashe="$emit('fashe')"></div>
  </transition>
  </div>
</template>

<script>
  import LoadingToast from './LoadingToast'
  import Dialog from './Dialog'
  export default{
props:['fundata'],
components:{
  LoadingToast,
  Dialog

},
methods:{

}
  }
</script>

<style>
  .fades-enter, .fades-leave-to{
          opacity: 0;
     }
    .fades-enter-active, .fades-leave-active{
      transition: opacity .2s;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/fun.vue